import ReactDOM from "react-dom";
import LogoWithName from "../logo/logoWithName.index";

export default function Loading() {
    return ReactDOM.createPortal(
        <div className="w-screen h-screen bg-white flex flex-col items-center justify-center">
            <LogoWithName />
            <div className="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>,
        document.getElementById("loading-root")!
    );
}
